import { cn } from "@/lib/utils";

import { METRIC_TONE_CLASS } from "./constants";
import { PlaceholderValue } from "./PlaceholderValue";
import { type MetricTone } from "./types";
import { getFiniteNumber, getMetricTone } from "./utils";

const MetricValue = ({
  highlightLow = false,
  tone,
  value,
}: {
  highlightLow?: boolean;
  tone?: MetricTone;
  value?: number | null;
}) => {
  const resolvedValue = getFiniteNumber(value);

  if (resolvedValue === undefined) {
    return <PlaceholderValue />;
  }

  const resolvedTone = tone ?? (highlightLow ? getMetricTone(resolvedValue) : "default");

  return (
    <span className={cn("tabular-nums", METRIC_TONE_CLASS[resolvedTone])}>{resolvedValue}</span>
  );
};

export { MetricValue };
